import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import {
  MemberDataVo,
  MemberVo,
  UserEditRequest,
  SendVerifyCodeRequest,
  UserUnbindRequest,
  MemberUserRequest,
  MemberSocial,
  SocialBindRequest,
  SecurityTwoStepList,
  SecurityReSetPasswordRequest,
  SecurityEnableTwoStep,
  SecurityDeviceList,
  SecurityLoginLogListVo
} from './types';

// 退出登录
export const loginOut = (): AxiosPromise<{ data: boolean }> => {
  return request({
    url: '/member/user/loginOut',
    method: 'post'
  });
};

// 获取个人中心全部数据
export const getUserMemberData = (): AxiosPromise<MemberDataVo> => {
  return request({
    url: '/member/user/memberData',
    method: 'get'
  });
};

//获取会员个人信息
export const getUserGetInfo = (): AxiosPromise<MemberVo> => {
  return request({
    url: '/member/user/getInfo',
    method: 'get'
  });
};

//编辑会员信息
export const editUserEdit = (data: UserEditRequest): AxiosPromise<boolean> => {
  return request({
    url: '/member/user/edit',
    method: 'post',
    data
  });
};

//发送手机号、邮箱验证码
export const sendVerifyCode = (data: SendVerifyCodeRequest): AxiosPromise<number> => {
  return request({
    url: '/member/user/sendVerifyCode',
    method: 'post',
    data
  });
};

// 解绑邮箱（假解绑主要是验证原邮箱） 0-解绑成功 1-解绑失败 2-验证码错误
export const UserUnbind = (data: UserUnbindRequest): AxiosPromise<number> => {
  return request({
    url: '/member/user/unbind',
    method: 'post',
    data
  });
};

// 绑定、与验证是同一个接口  0-成功 1-失败 2-验证码错误
export const memberUserBind = (data: MemberUserRequest): AxiosPromise<number> => {
  return request({
    url: '/member/user/bind',
    method: 'post',
    data
  });
};

// 获取脱敏信息   "1"-email "2"-phone
export const memberUserSensitiveVal = (
  source: number
): AxiosPromise<{
  email: string;
  phone: string;
}> => {
  return request({
    url: '/member/user/sensitiveVal',
    method: 'post',
    data: { source }
  });
};

// 第三方解绑
export const memberSocialUnbind = (data: number): AxiosPromise<boolean> => {
  return request({
    url: `/member/social/unBind/+${data}`,
    method: 'post'
  });
};

// 获取绑定社交账号列表
export const memberSocial = (): AxiosPromise<MemberSocial[]> => {
  return request({
    url: '/member/social',
    method: 'get'
  });
};

// 获取第三方绑定授权地址  0-gmail 1-facebook 2-twitter 3-paypal 4-apple 5-steam 6-discord
export const socialBindUrl = (params: { device?: string; source?: number; targetUrl?: string }): AxiosPromise<string> => {
  return request({
    url: '/member/social/bindUrl',
    method: 'get',
    params
  });
};

// 第三方绑定接口
export const socialBind = (data: SocialBindRequest): AxiosPromise<boolean> => {
  return request({
    url: '/member/social/bind',
    method: 'post',
    data
  });
};

// 登出其他访问设备
export const signOutOtherDevice = (): AxiosPromise<boolean> => {
  return request({
    url: '/member/security/signOutOtherDevice',
    method: 'post'
  });
};

// 两步验证列表接口
export const securityTwoStepList = (): AxiosPromise<SecurityTwoStepList[]> => {
  return request({
    url: '/member/security/twoStepList',
    method: 'post'
  });
};

// 注销
export const signOut = (): AxiosPromise<boolean> => {
  return request({
    url: '/member/security/signOut',
    method: 'post'
  });
};

// 删除授信设备
export const securityRemoveDevice = (id: number | string): AxiosPromise<boolean> => {
  return request({
    url: '/member/security/removeDevice',
    method: 'post',
    params: { id }
  });
};

// 删除全部授信设备
export const securityRemoveAllDevice = (): AxiosPromise<boolean> => {
  return request({
    url: '/member/security/removeAllDevice',
    method: 'post'
  });
};

// 更新密码
export const securityReSetPassword = (data: SecurityReSetPasswordRequest): AxiosPromise<boolean> => {
  return request({
    url: '/member/security/reSetPassword',
    method: 'post',
    data
  });
};

// 开启两步验证  两步验证类型 0-谷歌 1-邮箱 2-手机   谷歌、邮箱、手机验证码
export const securityEnableTwoStep = (data: { code?: string; type: number }): AxiosPromise<SecurityEnableTwoStep> => {
  return request({
    url: '/member/security/enableTwoStep',
    method: 'post',
    data
  });
};

// 查询访问设备、授信设备列表数据   设备类型 0-登录设备 1-授信设备
export const securityDeviceList = (deviceType: number): AxiosPromise<SecurityDeviceList[]> => {
  return request({
    url: '/member/security/deviceList',
    method: 'post',
    params: { deviceType }
  });
};

// 关闭两步验证  两步验证类型 0-谷歌 1-邮箱 2-手机
export const securityCloseTwoStep = (data: { type: number; code?: string }): AxiosPromise<SecurityEnableTwoStep> => {
  return request({
    url: '/member/security/closeTwoStep',
    method: 'post',
    data
  });
};

// 会员登录日志
export const securityLoginLogList = (): AxiosPromise<SecurityLoginLogListVo[]> => {
  return request({
    url: '/member/security/loginLogList',
    method: 'get'
  });
};
